<template>
    <b-modal
        v-model="modal"
        :id="'edit-afaq-question-modal'"
        :ref="'edit-afaq-question-modal'"
        :title="$t('admin.edit_question_and_answer')"
        :ok-title="$t('common.edit')"
        :cancel-title="$t('admin_cancel')"
        cancel-variant="outline-primary"
        ok-variant="primary"
        modal-class="apprentice-default-modal faq-question-edit"
        size="lg"
        @ok="onOk">
        <div class="edit-faq-question">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    :key="index"
                    show
                    variant="danger">
                    {{ error.message }}
                </b-alert>
            </div>

            <b-form-group
                class="question"
                label-for="question-input"
                :label="$t('admin.question')">
                <template v-slot:label> {{ $t('admin.question') }} <span class="required">*</span> </template>
                <b-form-input
                    id="question-input"
                    v-model="question"
                    :placeholder="$t('admin.question')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="answer"
                label-for="answer-input"
                :label="$t('admin.answer')">
                <template v-slot:label> {{ $t('admin.answer') }} <span class="required">*</span> </template>
                <ckeditor
                    v-model="answer"
                    @ready="onReady"
                    :editor="editor"
                    :config="editorConfig"
                    wrap>
                </ckeditor>
            </b-form-group>

            <b-form-group
                class="faq-question-labels-group"
                label-for="faq-question-labels-select"
                label="Labels">
                <design-2021-apprentice-multiselect-component
                    id="faq-question-labels-select"
                    v-model="tags"
                    :allow-empty="false"
                    label="name"
                    :options="afaqTagsIn"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                class="faq-question-category-visibility"
                label=":">
                <template v-slot:label> {{ $t('admin.visible_for') }} <span class="required">*</span> </template>
                <b-form-checkbox-group
                    class="apprentice-checkbox-group faq-question-visibility"
                    v-model="visibility"
                    :options="options"
                    name="visibility">
                </b-form-checkbox-group>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-afaq-edit-question-modal-component',
    props: ['afaqTagsIn', 'categoryIn'],
    data() {
        return {
            QAobject: null,
            categoryId: null,
            order: null,
            question: '',
            answer: '',
            visibility: [],
            tags: [],
            modal: false,
            options: [
                { text: this.$t('admin.students'), value: 'student' },
                { text: this.$t('admin.teachers'), value: 'teacher' },
            ],
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        '|',
                        'imageStyle:alignLeft',
                        'imageStyle:alignRight',
                        'imageStyle:alignCenter',
                        'imageStyle:alignBlockLeft',
                        'imageStyle:alignBlockRight',
                        'imageStyle:inline',
                        '|',
                        'linkImage',
                    ],
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {
                    uploadUrl: '',
                },
            },
            hasError: false,
            errors: {
                question: {
                    error: false,
                    message: this.$t('admin.name_field_cannot_be_empty'),
                },
                answer: {
                    error: false,
                    message: this.$t('admin.answer_field_cannot_be_empty'),
                },
                visibility: {
                    error: false,
                    message: this.$t('admin.visible_field_cannot_be_empty'),
                },
            },
        };
    },
    methods: {
        onOk(vbModalEvent) {
            if (this.foundError()) {
                vbModalEvent.preventDefault();
                return;
            }
            const tagIds = this.tags.map((tag) => tag.id);
            const data = new FormData();
            data.append('id', this.QAobject.id);
            data.append('categoryId', this.categoryId);
            data.append('question', this.question);
            data.append('answer', this.answer);
            data.append('order', this.order);
            for (let i = 0; i < this.visibility.length; i++) {
                data.append('visibility[' + i + ']', this.visibility[i]);
            }
            for (let i = 0; i < tagIds.length; i++) {
                data.append('tags[' + i + ']', tagIds[i]);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };
            this.alert.saving();
            this.axios.post(this.routes.afaqCategoryQuestionUpdate(this.categoryId), data, { headers: headers }).then(
                (response) => {
                    this.QAobject.update(response.data); //zou category moeten zijn.
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onReady() {
            const wrapper = document.querySelector('.ck-body-wrapper');
            wrapper.remove();
            const editor = document.querySelector('.ck-editor');
            editor.appendChild(wrapper);
        },

        show(data) {
            this.QAobject = data;
            this.categoryId = data.afaq_category_id;
            this.order = data.order;
            this.question = data.question !== null ? data.question : '';
            this.answer = data.answer !== null ? data.answer : '';
            this.tags = data.afaq_tags;
            this.visibility = [];
            if (data.student) {
                this.visibility.push('student');
            }
            if (data.teacher) {
                this.visibility.push('teacher');
            }
            this.editorConfig.simpleUpload.uploadUrl = this.routes.AdminAfaqImage(this.QAobject.id);
            this.clearError();
            this.modal = true;
        },

        clearError() {
            this.hasError = false;
            this.errors.question.error = false;
            this.errors.answer.error = false;
        },

        foundError() {
            this.clearError();

            if (this.question === '') {
                this.hasError = true;
                this.errors.question.error = true;
            }

            if (this.answer === '') {
                this.hasError = true;
                this.errors.answer.error = true;
            }

            if (this.visibility.length === 0) {
                this.hasError = true;
                this.errors.visibility.error = true;
            }

            return this.hasError;
        },
    },
};
</script>

<style scoped lang="scss">
.answer {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.faq-question-visibility ::v-deep {
    .custom-control-label {
        &:before,
        &:after {
            top: 0;
        }
    }
}
</style>
